import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { KEY_CODE } from '@commoncore/services/universal.service';
import { AppEvents } from '@commoncore/utils/app-events';

@Component({
  standalone:true,
  selector: 'app-change-access-confirmation',
  templateUrl: './change-access-confirmation.component.html',
  styleUrls: ['./change-access-confirmation.component.scss'],
  imports:[CommonModule]
})
export class ChangeAccessConfirmationComponent implements OnInit {
  universalService:any;
  folderName:any="";
  btnName:any="";
  showChangeAccessModal:boolean = false;
  totalFiles:any=0;
  @Output() confirmFileOpn = new EventEmitter();
  public selectedOption :string="move"

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.showChangeAccessModal) {
      this.confirmFileOperation(false);
    }else if (event.key === "Enter" && this.selectedOption == "move"){
      this.confirmFileOperation(false);
    }else if (event.key === "Enter" && this.selectedOption == "cancel"){
      this.confirmFileOperation(true);
    }

    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      $('#btn-cancel').addClass('no-bg');
      $('#btn-confirm').removeClass('no-bg');
      this.selectedOption = "continue"
    }

    if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      $('#btn-cancel').removeClass('no-bg');
      $('#btn-confirm').addClass('no-bg');
      this.selectedOption = "cancel"
    }
  }

  constructor(public globalService:GlobalService) { 
    this.setEnvObjects(globalService);
  }

  ngOnInit(): void {
    $('#btn-confirm').removeClass('no-bg');
    $('#btn-cancel').addClass('no-bg');
    AppEvents.optionSelected.subscribe(response=>{
      if(response["showChangeAccessConfirmation"]){
        this.totalFiles = response["noOfFiles"]
        this.showChangeAccessModal = true;
        this.folderName = this.universalService.destinationFolder["objectName"];
        this.btnName = response["buttonName"];
      }else if(response["showChangeAccessConfirmation"] == false){
        this.confirmFileOperation(false);
      }
    })
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
  }


  confirmFileOperation(value){
    if(value == true){
      this.confirmFileOpn.emit({"type":this.btnName,"confirm":true});
    }else{
      this.showChangeAccessModal = false;
      this.folderName = "";
      this.btnName = "";
      this.universalService.destinationFolder = {"objectName":"JioAICloud"};
      this.universalService.dragDropWithinApp = false;
      $('.ag-row').removeClass('disable-row'); // for list view
      // $('.folder-wrap').removeClass('disable-row'); // for grid view
      $(".gridItem").removeClass("disable-row");
      $(".fileThumbnail").removeClass("disable-row");
      // this.confirmFileOpn.emit({"type":this.btnName,"confirm":false});
    }
  }

}
